import { UndoOutlined } from '@ant-design/icons';
import React from 'react';

export const INVOICE_MULTI_SELECT_ACTION_CONFIG_FOR_BUYER = [
	{
		label: 'Mark Approved',
		statuses: ['pending', 'disputed'],
		toStatus: 'approved',
	},
	{
		label: 'Mark Disputed',
		statuses: ['pending'],
		toStatus: 'disputed',
	},
	{
		label: 'Mark Paid',
		statuses: ['approved', 'processing'],
		toStatus: 'paid',
	},
	{
		label: 'Mark Processing',
		statuses: ['approved'],
		toStatus: 'processing',
	},
	{
		label: 'Back to Approved',
		icon: <UndoOutlined translate="" />,
		statuses: ['processing'],
		toStatus: 'approved',
	},
	{
		label: 'Back To Processing',
		icon: <UndoOutlined translate="" />,
		statuses: ['paid'],
		toStatus: 'processing',
	},
	{
		label: 'Back To Pending',
		icon: <UndoOutlined translate="" />,
		statuses: ['approved', 'disputed'],
		toStatus: 'pending',
	},
];

export const INVOICE_MULTI_SELECT_ACTION_CONFIG_FOR_SUPPLIER = [
	{
		label: 'Mark Paid',
		statuses: ['approved', 'processing'],
		toStatus: 'paid',
	},
	{
		label: 'Publish',
		statuses: ['draft'],
		toStatus: 'pending',

		requireParams: ['invoicePDFLink'],
		disableMessage: 'Not all invoices have a PDF attached. Please upload a PDF to Publish.',
		refLink: '/supplier/invoices/detail/#/details',
	},
];
